import React from 'react';
import { AnimatedContainer } from '../styles';
import { ComponentUserRegisterProps } from '..';

import error from '../../../assets/error-image.svg';
import { ButtonContainer, ErrorContainer } from './styles';
import ButtonLoading from '../../../components/ButtonLoading';

export const PaymentError: React.FC<ComponentUserRegisterProps> = ({
  handleTryAgain,
}) => {
  return (
    <AnimatedContainer>
      <ErrorContainer>
        <h1>Erro no pagamento</h1>

        <img src={error} alt="" />
        <span>
          Ocorreu um erro de sistema e seu pagamento não foi concluído. Fique
          tranquilo, você poderá realizar a compra novamente no botão abaixo.
        </span>
        <ButtonContainer>
          <ButtonLoading
            isLoading={false}
            btnType="light"
            onClick={() => handleTryAgain()}
          >
            Tentar novamente
          </ButtonLoading>
        </ButtonContainer>
      </ErrorContainer>
    </AnimatedContainer>
  );
};
